const searchIcon = document.getElementById('navigation-search-button-element');
const navigationSearchSection = document.getElementById(
  'navigation-search-section',
);

const navigationHamburgerToggle = document.getElementById(
  'navigation-hamburger-toggle',
);
const navigationHamburgerIcon = document.getElementById(
  'navigation-hamburger-icon',
);
const navigationCloseIcon = document.getElementById('navigation-icon-close');

const menuElementDropdowns = document.querySelectorAll(
  '.navigation-dropdown-header',
);
const navigationContent = document.getElementById('navigation-content');
const navigationContentElements = document.getElementById(
  'navigation-content-elements',
);
const navigationLogo = document.getElementById('navigation-logo');

//Overlay from theme.liquid
const backgroundOverlay = document.getElementById('background-overlay');

let stopScrollingBehaviour = false;

function btnEventListeners() {
  searchIcon.addEventListener('click', () => {
    toggleNavigationSearch();
  });

  menuElementDropdowns.forEach((element) => {
    element.addEventListener('click', () => {
      navigationDropdown(element);
    });
  });

  navigationHamburgerIcon.addEventListener('click', () => {
    stopScrollingBehaviour = true;
    openHamburgerNavigation();
  });

  navigationCloseIcon.addEventListener('click', () => {
    stopScrollingBehaviour = false;
    closeHamburgerNavigation();
  });
}
btnEventListeners();

function openHamburgerNavigation() {
  //Hide search bar if opened already
  if (!navigationSearchSection.classList.contains('twcss-hidden')) {
    toggleNavigationSearch(false);
  }

  //Hamburger icon
  navigationHamburgerIcon.classList.add('twcss-animate-fade-out');

  //Close icon
  navigationCloseIcon.classList.remove('twcss-hidden');
  navigationCloseIcon.classList.add('twcss-animate-fade-in');

  searchIcon.classList.add('twcss-animate-fade-out');

  navigationContent.classList.replace('twcss-hidden', 'twcss-inline-block');
  document.body.classList.add('twcss-overflow-y-hidden');
  navigationContent.classList.add('twcss-overflow-y-auto');

  backgroundOverlay.classList.replace('twcss-hidden', '!twcss-block');

  setTimeout(() => {
    searchIcon.classList.add('twcss-hidden');
  }, 300);

  pauseSliderVideo(true);
}

function closeHamburgerNavigation() {
  navigationCloseIcon.classList.add('twcss-animate-fade-out');
  navigationCloseIcon.classList.remove('twcss-animate-fade-in', 'twcss-hidden');

  searchIcon.classList.remove('twcss-hidden');
  searchIcon.classList.replace(
    'twcss-animate-fade-out',
    'twcss-animate-fade-in',
  );

  navigationHamburgerIcon.classList.replace(
    'twcss-animate-fade-out',
    'twcss-animate-fade-in',
  );

  navigationContent.classList.replace(
    'twcss-animate-slide-left-in',
    'twcss-animate-slide-left-out',
  );
  backgroundOverlay.classList.replace(
    'twcss-animate-fade-in',
    'twcss-animate-fade-out',
  );

  setTimeout(() => {
    navigationContent.classList.replace('twcss-inline-block', 'twcss-hidden');
    navigationContent.classList.replace(
      'twcss-animate-slide-left-out',
      'twcss-animate-slide-left-in',
    );
    document.body.classList.remove('twcss-overflow-y-hidden');
    navigationContent.classList.remove('twcss-overflow-y-auto');

    backgroundOverlay.classList.replace('!twcss-block', 'twcss-hidden');
    backgroundOverlay.classList.replace(
      'twcss-animate-fade-out',
      'twcss-animate-fade-in',
    );

    navigationCloseIcon.classList.replace(
      'twcss-animate-fade-out',
      'twcss-animate-fade-in',
    );
    navigationCloseIcon.classList.add('twcss-hidden');
  }, 300);
  pauseSliderVideo(false);
}

function applyLeftSizeOffset() {
  let offsetLeft = navigationHamburgerToggle.offsetLeft;
  navigationContentElements.style.paddingLeft = `${offsetLeft}px`;

  if (window.innerWidth >= 990) {
    navigationContentElements.style.width = `${navigationLogo.offsetLeft}px`;
  } else {
    navigationContentElements.style.width = null;
  }
}
applyLeftSizeOffset();

function resizeEventListeners() {
  window.addEventListener('resize', () => {
    applyLeftSizeOffset();
  });
}
resizeEventListeners();

function toggleNavigationSearch(overlay = true) {
  if (navigationSearchSection.classList.contains('twcss-hidden')) {
    navigationSearchSection.classList.remove('twcss-hidden');
    navigationSearchSection.classList.add('twcss-animate-search-in');

    searchIcon.classList.replace('twcss-text-white', 'twcss-text-red');
    searchIcon.classList.remove('hover:twcss-text-red');

    if (overlay) {
      backgroundOverlay.classList.replace('twcss-hidden', '!twcss-block');
    }
    pauseSliderVideo(true);
  } else {
    navigationSearchSection.classList.replace(
      'twcss-animate-search-in',
      'twcss-animate-search-out',
    );
    if (overlay) {
      backgroundOverlay.classList.replace(
        'twcss-animate-fade-in',
        'twcss-animate-fade-out',
      );
    }
    setTimeout(() => {
      navigationSearchSection.classList.add('twcss-hidden');
      navigationSearchSection.classList.replace(
        'twcss-animate-search-out',
        'twcss-animate-search-in',
      );
      searchIcon.classList.replace('twcss-text-red', 'twcss-text-white');
      searchIcon.classList.add('hover:twcss-text-red');

      if (overlay) {
        backgroundOverlay.classList.replace('!twcss-block', 'twcss-hidden');
        backgroundOverlay.classList.replace(
          'twcss-animate-fade-out',
          'twcss-animate-fade-in',
        );
      }
    }, 300);
    pauseSliderVideo(false);
  }
}

function navigationDropdown(element) {
  const dropdownContent = element.parentNode.querySelector(
    '.navigation-dropdown-content',
  );

  const dropdownHeader = {
    title: element.querySelector('.dropdown-title'),
    arrow: element.querySelector('.dropdown-arrow'),
  };

  if (dropdownContent.classList.contains('twcss-hidden')) {
    dropdownContent.classList.remove('twcss-hidden');
    dropdownHeader.title.classList.replace(
      'twcss-text-white',
      'twcss-text-red',
    );

    dropdownHeader.arrow.classList.replace(
      'twcss-rotate-0',
      'twcss-rotate-180',
    );
    dropdownHeader.arrow.classList.replace(
      'twcss-text-white',
      'twcss-text-red',
    );
  } else {
    dropdownContent.classList.replace(
      'twcss-animate-dropdown-in',
      'twcss-animate-dropdown-out',
    );
    setTimeout(() => {
      dropdownContent.classList.add('twcss-hidden');
      dropdownContent.classList.replace(
        'twcss-animate-dropdown-out',
        'twcss-animate-dropdown-in',
      );
      dropdownHeader.title.classList.replace(
        'twcss-text-red',
        'twcss-text-white',
      );

      dropdownHeader.arrow.classList.replace(
        'twcss-rotate-180',
        'twcss-rotate-0',
      );
      dropdownHeader.arrow.classList.replace(
        'twcss-text-red',
        'twcss-text-white',
      );
    }, 300);
  }
}

function pauseSliderVideo(state) {
  const videoSlide = document.getElementById('hero-video-slide');
  if (videoSlide !== null) {
    if (videoSlide.querySelector('video') != null) {
      state
        ? videoSlide.querySelector('video').pause()
        : videoSlide.querySelector('video').play();
    }
  }
}

function navScrollEvent() {
  window.addEventListener('scroll', () => {
    applySlidingNavigation();
  });
}
navScrollEvent();

function applySlidingNavigation() {
  const headerNavigation = document.getElementById('main-header-navigation');

  //APPLY STICKY TO: shopify-section shopify-section-group-header-group section-header

  if (
    !stopScrollingBehaviour &&
    (headerNavigation != null || headerNavigation != undefined)
  ) {
    if (this.oldScroll > this.scrollY) {
      headerNavigation.parentElement.classList.add(
        'twcss-sticky',
        'twcss-top-0',
      );
      headerNavigation.parentElement.classList.remove('twcss-animate-nav-out');
      headerNavigation.parentElement.classList.add('twcss-animate-nav-in');
    } else if (calculateNavOffset() < this.scrollY) {
      headerNavigation.parentElement.classList.replace(
        'twcss-animate-nav-in',
        'twcss-animate-nav-out',
      );

      setTimeout(() => {
        headerNavigation.parentElement.classList.remove(
          'twcss-sticky',
          'twcss-top-0',
        );
      }, 300);
    }
    this.oldScroll = this.scrollY;
  }
}

function calculateNavOffset() {
  let navigationHeight = document.getElementById(
    'main-header-navigation',
  ).offsetHeight;
  let announcementHeight = 0;
  if (document.getElementById('announcement-bar') != null) {
    announcementHeight =
      document.getElementById('announcement-bar').offsetHeight;
  }

  return Number(navigationHeight + announcementHeight);
}
